'use client';

import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';

const AlternatePartTitle = () => {
  const t = useTranslations();
  return (
 <CatHeading
     className='text-capitalize cat-u-margin-bottom-lg cat-u-theme-typography-title'
      variant="title">
      {t('COMPARE_ALT_PARTS')}
    </CatHeading>
  );
};

export default AlternatePartTitle;
